<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :maskClosable="false" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-collapse v-model="activeKey">
        <a-collapse-panel key="1" header="商家信息" class="goods-collapse">
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="posType">
                <span slot="label"><a-tooltip>进件POS类型 <template slot="title">进件POS类型 —按接入系统做控制 </template></a-tooltip> </span>
                <a-input v-model="form.posType" disabled :maxLength="32" :placeholder="$t('请输入')+'机构代码'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="orgCode">
                <span slot="label"><a-tooltip>机构代码<template slot="title">机构代码 （合作方在拉卡拉的标识，请联系业务员</template></a-tooltip></span>
                <a-input v-model="form.orgCode" disabled :maxLength="32" :placeholder="$t('请输入')+'机构代码'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merRegName">
                <span slot="label"> <a-tooltip>商户注册名称<template slot="title">长度不小于4个汉字；营业执照商户可填营业执照名称（执照名称超过20个字的，注册名称可不与执照名称一致），小微商户入网不得含有“有限公司”。【8~40字符，不可为纯数字】</template></a-tooltip> </span>
                <a-input v-model="form.merRegName" :maxLength="80" :placeholder="$t('请输入')+'商户注册名称'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merBizName">
                <span slot="label"> <a-tooltip>商户经营名称<template slot="title">为空时，同商户注册名称，4-64个字符 【4~64字符，不可为纯数字】</template></a-tooltip> </span>
                <a-input v-model="form.merBizName" :maxLength="64" :placeholder="$t('请输入')+'商户经营名称'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merAreaxId">
                <span slot="label">  <a-tooltip>商户地区<template slot="title">商户地区</template></a-tooltip> </span>
                <a-cascader :options="areaList"
                            :field-names="{ label: 'areaName', value: 'areaId', children: 'children'}"
                            :placeholder="$t('请输入')+$t('商家.所在地')"
                            style="width: 100%" v-model="areaSelected" allowClear @change="onAreaChange">
                </a-cascader>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merRegDistCode">
                <span slot="label">  <a-tooltip>商户地区代码<template slot="title">商户地区代码</template></a-tooltip> </span>
                <a-input v-model="form.merRegDistCode" disabled :maxLength="8" :placeholder="$t('请输入')+'商户地区代码'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merRegAddr">
                <span slot="label"> <a-tooltip>商户详细地址<template slot="title">去除省，市，区后的详细地址，6-80字符</template></a-tooltip> </span>
                <a-input v-model="form.merRegAddr" :maxLength="80" :placeholder="$t('请输入')+'商户详细地址'"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="industryId" >
                <span slot="label" > <a-tooltip>主营行业<template slot="title">主营行业</template></a-tooltip></span>
                <a-cascader :options="industryList"
                            :field-names="{ label: 'categoryName', value: 'id', children: 'children'}"
                            :placeholder="$t('请选择')+'主营行业'"
                            style="width: 100%" v-model="industrySelected" allowClear @change="onIndustryChange">
                </a-cascader>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="mccCode">
                <span slot="label"> <a-tooltip>商户MCC编号<template slot="title">商户MCC编号</template></a-tooltip></span>
                <a-input v-model="form.mccCode" disabled :maxLength="8" :placeholder="$t('请选择')+'主营行业'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merBusiContent">
                <span slot="label"><a-tooltip>商户经营内容<template slot="title">商户经营内容</template></a-tooltip></span>
                <a-select v-model="form.merBusiContent" :placeholder="$t('请输入')+'商户经营内容'">
                  <a-select-option v-for="(item, index) in customDict.MerchantBusinessContentEnum" :value="item.type" :key="index">{{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12" v-if="merchantType===1">
              <a-form-model-item prop="fileDataResult.businessLicenseImg" >
                <span slot="label" ><a-tooltip>营业执照照片<template slot="title">营业执照照片 小微商户可不传，其它必传</template></a-tooltip> </span>
                <oss-upload-single v-model="form.fileDataResult.businessLicenseImg" :max-size="5" prefix="merchant" type="img"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12" v-if="merchantType===1">
              <a-form-model-item prop="merBlisName">
                <span slot="label"> <a-tooltip>营业执照名称<template slot="title">1、主体为“小微/个人卖家”时，不填。2、主体为“个体工商户/企业”时，请上传营业执照。3、主体为“政府机关/事业单位/社会组织”时，请上传登记证书。</template></a-tooltip>  </span>
                <a-input v-model="form.merBlisName" :maxLength="80" :placeholder="$t('请输入')+'营业执照名称'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12" v-if="merchantType===1">
              <a-form-model-item prop="merBlis">
                <span slot="label"> <a-tooltip>营业执照号<template slot="title">营业执照号</template></a-tooltip> </span>
                <a-input v-model="form.merBlis" :maxLength="40" :placeholder="$t('请输入')+'营业执照号'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12" v-if="merchantType===1">
              <a-form-model-item prop="merBlisStDt">
                <span slot="label"> <a-tooltip>营业执照开始日期<template slot="title">营业执照开始日期</template></a-tooltip> </span>
                <a-date-picker style="width: 100%" v-model="form.merBlisStDt" valueFormat="YYYY-MM-DD" allow-clear/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12" v-if="merchantType===1">
              <a-form-model-item prop="merBlisExpDt">
                <span slot="label"> <a-tooltip>营业执照有效期<template slot="title">营业执照有效期 9999-12-31</template></a-tooltip> </span>
                <a-date-picker style="width: 80%" v-model="form.merBlisExpDt" valueFormat="YYYY-MM-DD" allow-clear/>
                <a @click="merBlisExpDtLong">长期?</a>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-collapse-panel>
        <a-collapse-panel key="2" header="联系人信息" class="goods-collapse">
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="larName">
                <span slot="label"><a-tooltip>法人姓名<template slot="title">法人姓名</template></a-tooltip></span>
                <a-input v-model="form.larName" :maxLength="20" :placeholder="$t('请输入')+'法人姓名'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="larIdcard">
                <span slot="label"><a-tooltip>法人身份证号码<template slot="title">法人身份证号码</template></a-tooltip>        </span>
                <a-input v-model="form.larIdcard" :maxLength="40" :placeholder="$t('请输入')+'法人身份证号码'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.legalCardNational">
                <span slot="label"><a-tooltip>法人身份证国徽面<template slot="title">法人身份证国徽面</template></a-tooltip>        </span>
                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.legalCardNational" prefix="merchant" type="img"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.legalCardFace">
                <span slot="label"><a-tooltip>法人身份证人像面<template slot="title">法人身份证人像面</template></a-tooltip>        </span>
                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.legalCardFace" prefix="merchant" type="img"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="larIdcardStDt">
                <span slot="label"><a-tooltip>法人身份证开始日期<template slot="title">法人身份证开始日期</template></a-tooltip>        </span>
                <a-date-picker style="width: 100%" v-model="form.larIdcardStDt" valueFormat="YYYY-MM-DD" allow-clear/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="larIdcardExpDt">
                <span slot="label"><a-tooltip>法人身份证有效期<template slot="title">法人身份证有效期</template></a-tooltip>        </span>
                <a-date-picker style="width: 100%" v-model="form.larIdcardExpDt" valueFormat="YYYY-MM-DD" allow-clear/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merContactName">
                <span slot="label"><a-tooltip>商户联系人<template slot="title">商户联系人</template></a-tooltip>        </span>
                <a-input v-model="form.merContactName" :maxLength="32" :placeholder="$t('请输入')+'商户联系人'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merContactMobile">
                <span slot="label"><a-tooltip>商户联系人手机<template slot="title">商户联系人手机号码</template></a-tooltip>        </span>
                <a-input v-model="form.merContactMobile" :maxLength="20" :placeholder="$t('请输入')+'商户联系人手机号码'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merContactEmail">
                <span slot="label"><a-tooltip>商户联系人邮箱<template slot="title">商户联系人邮箱</template></a-tooltip>        </span>
                <a-input v-model="form.merContactEmail" :maxLength="64" :placeholder="$t('请输入')+'商户联系人邮箱'"/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-collapse-panel>
        <a-collapse-panel key="3" header="结算信息" class="goods-collapse">
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="acctTypeCode">
                <span slot="label"><a-tooltip>结算账户性质<template slot="title">结算账户性质</template></a-tooltip>        </span>
                <a-radio-group  button-style="solid" v-model="form.acctTypeCode" :placeholder="$t('请输入')+'结算账户性质'">
                  <a-radio-button v-for="(item, index) in this.customDict.SettleAccountTypeEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-radio-button>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.bankCardImg">
                <span slot="label"><a-tooltip>银行卡<template slot="title">银行卡图片</template></a-tooltip>        </span>
                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.bankCardImg" prefix="merchant" type="img"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="openingBankName">
                <span slot="label"><a-tooltip>结算账户开户行名称<template slot="title">结算账户开户行名称</template></a-tooltip>        </span>
                <a-button  @click="$refs.RadioBranchSelectForm.openClearBranch(form.openingBankCode)" style="text-align: left; width: 100%" >
                  <span style="color: dodgerblue">{{this.getBranchName()}} </span>
                </a-button>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="openingBankCode">
                <span slot="label"><a-tooltip>结算账户开户行号<template slot="title">结算账户开户行号</template></a-tooltip>        </span>
                <a-input v-model="form.openingBankCode" disabled :maxLength="20" :placeholder="$t('请输入')+'结算账户开户行号'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="clearingBankCode">
                <span slot="label"><a-tooltip>结算账户清算行号<template slot="title">结算账户清算行号</template></a-tooltip>        </span>
                <a-input v-model="form.clearingBankCode" disabled :maxLength="20" :placeholder="$t('请输入')+'结算账户清算行号'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="acctNo">
                <span slot="label"><a-tooltip>结算账户账号<template slot="title">结算账户账号</template></a-tooltip>        </span>
                <a-input v-model="form.acctNo" :maxLength="40" :placeholder="$t('请输入')+'结算账户账号'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="acctName">
                <span slot="label"><a-tooltip>结算账户名称<template slot="title">1、选择经营者个人银行卡时，开户名称必须与身份证姓名一致。2、选择对公账户时，开户名称必须与营业执照上的“商户名称”一致。</template></a-tooltip>        </span>
                <a-input v-model="form.acctName" :maxLength="40" :placeholder="$t('请输入')+'结算账户名称'"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.settleCardNational">
                <span slot="label"><a-tooltip>结算人身份证国徽面<template slot="title">结算人身份证国徽面 ,不填的话 取法人身份证</template></a-tooltip>        </span>
                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.settleCardNational" prefix="merchant" type="img"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.settleCardFace">
                <span slot="label"><a-tooltip>结算人身份证人像面<template slot="title">结算人身份证人像面 ,不填的话 取法人身份证</template></a-tooltip>        </span>
                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.settleCardFace" prefix="merchant" type="img"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="acctIdcard">
                <span slot="label"><a-tooltip>结算人证件号码<template slot="title">结算人证件号码  为空时，判断为同法人 </template></a-tooltip>        </span>
                <a-input v-model="form.acctIdcard" :maxLength="40" :placeholder="$t('请输入')+'结算人证件号码'"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="acctIdDt">
                <span slot="label"><a-tooltip>结算人证件有效期<template slot="title">结算人证件有效期 为空时，判断为同法人</template></a-tooltip>        </span>
                <a-input v-model="form.acctIdDt" style="width: 70%" :maxLength="10" :placeholder="$t('请输入')+'结算人证件有效期'"/>
                <a @click="sameSettleLegal">结算人同法人?</a>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="settlePeriod">
                <span slot="label"><a-tooltip>结算周期<template slot="title">结算周期</template></a-tooltip>        </span>
                <a-select v-model="form.settlePeriod" :placeholder="$t('请输入')+'结算周期'">
                  <a-select-option v-for="(item, index) in customDict.SettleCycleEnum" :value="item.type" :key="index">{{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
<!--            <a-col :span="12">
              <a-form-model-item prop="feeDataList">
                <span slot="label"><a-tooltip>费率信息<template slot="title">集合费率信息集合</template></a-tooltip>        </span>
                <a-button  v-model="form.feeDataList" type="dashed" style="text-align: left; width: 100%" @click="openRateType" danger>
                  <span style="color: dodgerblue">  {{this.getRateTypeName()}}</span>
                </a-button>
              </a-form-model-item>
            </a-col>-->
            <a-col :span="12">
              <a-form-model-item prop="limitAmount">
                <span slot="label"><a-tooltip>收款上限<template slot="title">不填表示不设上限 ,达到上限后将切换到下一个商户号</template></a-tooltip>        </span>
                <a-input-number v-model="form.limitAmount" style="width: 80%" :min="0" :max="9999999999" :step="0.01" placeholder="收款上限"  /><span>元</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="taxPointRange">
                <span slot="label"><a-tooltip>收款税点区间<template slot="title">例如0-1 或者 0.03-0.12 ,代表这个商户号只收这个税点区间的款 0.03≤税点≤0.12</template></a-tooltip>        </span>
                <a-input v-model="form.taxPointRange"   />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-collapse-panel>

        <a-collapse-panel key="4" header="图片信息" class="goods-collapse">
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.doorImg">
                <span slot="label"><a-tooltip>商户门头照<template slot="title">商户门头照</template></a-tooltip>        </span>
                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.doorImg" prefix="merchant" type="img"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.interiorImg">
                <span slot="label"><a-tooltip>商铺内部照片<template slot="title">商铺内部照片</template></a-tooltip>        </span>
                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.interiorImg" prefix="merchant" type="img"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.offlinePaperAgreement">
                <span slot="label"><a-tooltip>线下纸质协议<template slot="title">线下纸质协议</template></a-tooltip>        </span>
                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.offlinePaperAgreement" prefix="merchant" type="null"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.networkAgreement">
                <span slot="label"><a-tooltip>电子协议<template slot="title">电子协议</template></a-tooltip>        </span>
                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.networkAgreement" prefix="merchant" type="null"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.cooperation">
                <span slot="label"><a-tooltip>合作资质证明<template slot="title">合作资质证明</template></a-tooltip>        </span>
                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.cooperation" prefix="merchant" type="null"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.foodBusiness">
                <span slot="label"><a-tooltip>食品经营相关资质<template slot="title">食品经营相关资质</template></a-tooltip>        </span>
                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.foodBusiness" prefix="merchant" type="null"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.unLegalSettleAuthorization">
                <span slot="label"><a-tooltip>非法人结算授权书<template slot="title">非法人结算授权书</template></a-tooltip>        </span>
                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.unLegalSettleAuthorization" prefix="merchant" type="null"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.cooperationAgreement">
                <span slot="label"><a-tooltip>合作协议<template slot="title"><a-button type="link" @click="downLoadTemp">下载模板</a-button></template></a-tooltip>        </span>
                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.cooperationAgreement" prefix="merchant" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="fileDataResult.otherFile">
                <span slot="label"><a-tooltip>其他<template slot="title">其他</template></a-tooltip>        </span>
                <oss-upload-single style="width:100px;height: 80px " :max-size="5" v-model="form.fileDataResult.otherFile" prefix="merchant" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-collapse-panel>
        <a-collapse-panel key="5" header="其他信息" class="goods-collapse">
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="contractId">
                <span slot="label"><a-tooltip>进件ID<template slot="title">进件ID</template></a-tooltip>        </span>
                <span>{{form.contractId}}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="contractStatus">
                <span slot="label"><a-tooltip>状态<template slot="title">状态</template></a-tooltip>        </span>
                <custom-dict-tag :options="customDict.ExtraApplyStatusEnum" :value="form.contractStatus"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="contractMemo">
                <span slot="label"><a-tooltip>进件描述<template slot="title">进件描述进件审核通过，返回“审核通过”,进件审核驳回，返回具体的驳回理由。</template></a-tooltip>        </span>
                <span>{{form.contractMemo}}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merInnerNo">
                <span slot="label"><a-tooltip>拉卡拉内部商户号<template slot="title">拉卡拉内部商户号该属性审核通过才有</template></a-tooltip>        </span>
                <span>{{form.merInnerNo}}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merCupNo">
                <span slot="label"><a-tooltip>银联商户号<template slot="title">银联商户号该属性审核通过才有</template></a-tooltip>        </span>
                <span>{{form.merCupNo}}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-collapse-panel>

      </a-collapse>





<!--      <a-form-model-item prop="devSerialNo">
        <span slot="label"><a-tooltip>终端设备序列号<template slot="title">终端设备序列号</template></a-tooltip>        </span>
        <a-input v-model="form.devSerialNo" :maxLength="64" :placeholder="$t('请输入')+'终端设备序列号'"/>
      </a-form-model-item>
      <a-form-model-item prop="devTypeName">
        <span slot="label"><a-tooltip>设备型号<template slot="title">设备型号</template></a-tooltip>        </span>
        <a-input v-model="form.devTypeName" :maxLength="32" :placeholder="$t('请输入')+'设备型号'"/>
      </a-form-model-item>
      <a-form-model-item prop="termVer">
        <span slot="label"><a-tooltip>终端版本号<template slot="title">终端版本号</template></a-tooltip>        </span>
        <a-input v-model="form.termVer" :maxLength="32" :placeholder="$t('请输入')+'终端版本号'"/>
      </a-form-model-item>
      <a-form-model-item prop="salesStaff">
        <span slot="label"><a-tooltip>销售人员<template slot="title">销售人员</template></a-tooltip>        </span>
        <a-input v-model="form.salesStaff" :maxLength="15" :placeholder="$t('请输入')+'销售人员'"/>
      </a-form-model-item>
      <a-form-model-item prop="termNum">
        <span slot="label"><a-tooltip>终端数量<template slot="title">终端数量</template></a-tooltip>        </span>
        <a-input v-model="form.termNum" :maxLength="8" :placeholder="$t('请输入')+'终端数量'"/>
      </a-form-model-item>-->
<!--      <a-form-model-item prop="feeAssumeType">
        <span slot="label"><a-tooltip>大额理财- 手续费承担方<template slot="title">大额理财- 手续费承担方</template></a-tooltip>        </span>
      </a-form-model-item>
      <a-form-model-item prop="amountOfMonth">
        <span slot="label"><a-tooltip>大额理财- 最小月交易额<template slot="title">大额理财- 最小月交易额</template></a-tooltip>        </span>
        <a-input v-model="form.amountOfMonth" :maxLength="23"
                 :placeholder="$t('请输入')+'大额理财- 最小月交易额'"/>
      </a-form-model-item>
      <a-form-model-item prop="serviceFee">
        <span slot="label"><a-tooltip>大额理财- 收取服务费<template slot="title">大额理财- 收取服务费</template></a-tooltip>        </span>
        <a-input v-model="form.serviceFee" :maxLength="32"
                 :placeholder="$t('请输入')+'大额理财- 收取服务费'"/>
      </a-form-model-item>-->

      <radio-branch-select-form ref="RadioBranchSelectForm" @branchSelect="indexBranchSelect"></radio-branch-select-form>
      <fee-rate-form ref="feeRateForm" @rateType="indexRateType"></fee-rate-form>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getExtraApplyLakala, addExtraApplyLakala, updateExtraApplyLakala} from '@/api/merchant/extraApplyLakala'
import {getApplyByMerchantId} from '@/api/merchant/merchantApply'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import Editor from '@/components/Editor'
import {areaListLakala, areaListTree} from "@/api/logistics";
import {listIndustry} from "@/api/merchant/industry";
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";
import RadioBranchSelectForm from '@/views/merchant/branch/modules/RadioSelectForm'
import FeeRateForm from "@/views/merchant/applyLakala/modules/FeeRateForm.vue";
import {downLoadExcel} from "@/utils/excelDownload";

export default {
  name: 'CreateForm',
  props: {
    merchantId:{
      type: String,
      required: true
    },
    merchantType:{
      type: Number,
      required: true,
      default: 1
    }
  },
  components: {
    FeeRateForm,
    OssUploadSingle,
    CustomDictTag,
    RadioBranchSelectForm,
    Editor
  },
  data() {
    return {
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      submitLoading: false,
      formTitle: '请填写真实信息,否则将进件不成功',
      loading: '',
      activeKey: [1, 2, 3, 4, 5],
      areaList: [],
      areaSelected: [],
      industryList: [],
      industrySelected: [],
      // 表单参数
      form: {
        id: null,
        merchantId: this.merchantId,
        orderNo: null,
        posType: "B2B_CASHIER_DESK",
        orgCode: '986405',
        merRegName: null,
        merBizName: null,
        merAreaxId: null,
        merRegDistCode: null,
        merRegAddr: null,
        mccCode: null,
        merBlisName: null,
        merBlis: null,
        merBlisStDt: null,
        merBlisExpDt: null,
        merBusiContent: undefined,
        larName: null,
        larIdType: "01",
        larIdcard: null,
        larIdcardStDt: null,
        larIdcardExpDt: null,
        merContactMobile: null,
        merContactName: null,
        merContactEmail: null,
        shopName: null,
        shopDistCode: null,
        shopAddr: null,
        shopContactName: null,
        shopContactMobile: null,
        openingBankCode: null,
        openingBankName: null,
        clearingBankCode: null,
        acctNo: null,
        acctName: null,
        acctTypeCode: null,
        settlePeriod: "T+1",
        acctIdType: "01",
        acctIdcard: null,
        acctIdDt: null,
        devSerialNo: null,
        devTypeName: null,
        termVer: null,
        salesStaff: null,
        termNum: null,
        feeDataList: null,
        fileDataList: null,
        contractNo: null,
        feeAssumeType: null,
        amountOfMonth: null,
        serviceFee: null,
        contractId: null,
        contractStatus: '0',
        contractMemo: null,
        merInnerNo: null,
        merCupNo: null,
        limitAmount: null,
        taxPointRange: '0-1',
        fileDataResult:{
          settleCardNational: null,
          settleCardFace: null,
          legalCardNational: null,
          legalCardFace: null,
          businessLicenseImg : null,
          bankCardImg : null,
          doorImg: undefined, //商户门头照
          interiorImg: undefined, //商铺内部照片
          offlinePaperAgreement: undefined, //线下纸质协议
          networkAgreement: undefined,  //电子协议
          cooperation: undefined,  //合作资质证明
          foodBusiness: undefined,  //食品经营相关资质
          unLegalSettleAuthorization : undefined,  //  非法人结算授权书
          cooperationAgreement: undefined, //合作协议
          otherFile: undefined,//其他
        },
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        acctTypeCode: [{ required: true, message: '结算账户性质'+this.$t('不能为空'), trigger: 'change' }],
        posType: [{ required: true, message: '进件POS类型'+this.$t('不能为空'), trigger: 'change' }],
        orgCode: [{ required: true, message: '机构代码'+this.$t('不能为空'), trigger: 'change' }],
        merRegName: [{ required: true, message: '商户注册名称'+this.$t('不能为空'), trigger: 'blur' }],
        merBizName: [{ required: true, message: '商户简称'+this.$t('不能为空'), trigger: 'blur' }],
        merAreaxId: [{ required: false, message: '商户所在地'+this.$t('不能为空'), trigger: 'change' }],
        merRegDistCode: [{ required: true, message: '商户所在地'+this.$t('不能为空'), trigger: 'change' }],
        merBlis: [{ required: this.merchantType===1, message: '营业执照号'+this.$t('不能为空'), trigger: 'blur' }],
        merBlisName: [{ required: this.merchantType===1, message: '营业执照名称'+this.$t('不能为空'), trigger: 'blur' }],
        merBlisStDt: [{ required: this.merchantType===1, message: '营业执照开始日期'+this.$t('不能为空'), trigger: 'change' }],
        merBlisExpDt: [{ required: this.merchantType===1, message: '营业执照有效期'+this.$t('不能为空'), trigger: 'change' }],
        merRegAddr: [{ required: true, message: '商户注册地址'+this.$t('不能为空'), trigger: 'change' }],
        mccCode: [{ required: true, message: '商户行业'+this.$t('不能为空'), trigger: 'change' }],
        merBusiContent: [{ required: true, message: '商户经营内容'+this.$t('不能为空'), trigger: 'change' }],
        larName: [{ required: '结算人姓名'+this.$t('不能为空'), trigger: 'change' }],
        larIdType: [{ required: true, message: '结算人身份证类型'+this.$t('不能为空'), trigger: 'change' }],
        larIdcard: [{ required: true, message: '结算人身份证号'+this.$t('不能为空'), trigger: 'change' }],
        larIdcardStDt: [{ required: true, message: '结算人身份证开始日期'+this.$t('不能为空'), trigger: 'change' }],
        larIdcardExpDt: [{ required: true, message: '结算人身份证结束日期'+this.$t('不能为空'), trigger: 'change' }],
        merContactMobile: [{ required: true, message: '商户联系人手机号'+this.$t('不能为空'), trigger: 'blur' }],
        merContactName: [{ required: true, message: '商户联系人姓名'+this.$t('不能为空'), trigger: 'blur' }],
        merContactEmail: [{ required: true, message: '商户联系人邮箱'+this.$t('不能为空'), trigger: 'blur' }],
        shopName: [{ required: true, message: '商铺名称'+this.$t('不能为空'), trigger: 'change' }],
        shopDistCode: [{ required: true, message: '商铺所在地'+this.$t('不能为空'), trigger: 'change' }],
        shopAddr: [{ required: true, message: '商铺地址'+this.$t('不能为空'), trigger: 'change' }],
        shopContactName: [{ required: true, message: '商铺联系人姓名'+this.$t('不能为空'), trigger: 'change' }],
        shopContactMobile: [{ required: true, message: '商铺联系人手机号'+this.$t('不能为空'), trigger: 'change' }],
        openingBankCode: [{ required: true, message: '结算账户开户行代码'+this.$t('不能为空'), trigger: 'change' }],
        openingBankName: [{ required: true, message: '结算账户开户行名称'+this.$t('不能为空'), trigger: 'change' }],
        clearingBankCode: [{ required: true, message: '结算账户清算行代码'+this.$t('不能为空'), trigger: 'change' }],
        acctNo: [{ required: true, message: '结算账户号'+this.$t('不能为空'), trigger: 'change' }],
        acctName: [{ required: true, message: '结算账户名称'+this.$t('不能为空'), trigger: 'change' }],
        settlePeriod: [{ required: true, message: '结算周期'+this.$t('不能为空'), trigger: 'change' }],
        feeDataList: [{ required: true, message: '费率'+this.$t('不能为空'), trigger: 'change' }],
        fileDataResult:{
          businessLicenseImg: [{ required: this.merchantType===1, message: '营业执照'+this.$t('不能为空'), trigger: 'change' }],
          legalCardNational: [{ required: true, message: '法人身份证国徽面'+this.$t('不能为空'), trigger: 'change' }],
          legalCardFace: [{ required: true, message: '法人身份证人像面'+this.$t('不能为空'), trigger: 'change' }],
          cooperationAgreement: [{ required: true, message: '合作协议'+this.$t('不能为空'), trigger: 'change' }],
          bankCardImg: [{ required: true, message: '银行卡'+this.$t('不能为空'), trigger: 'change' }],
          doorImg: [{ required: true, message: '商户门头照'+this.$t('不能为空'), trigger: 'change' }],
          interiorImg: [{ required: true, message: '商铺内部照片'+this.$t('不能为空'), trigger: 'change' }],
        }
      }
    }
  },
  filters: {},
  created() {
    this.getAreaTree()
    this.getIndustryList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    makeRequiredIfMerType1(label){
      return (rule, value, callback) => {
        if (this.merchantType === 1 && (!value || value === '')) {
          callback(new Error(label + this.$t('不能为空')))
        } else {
          callback()
        }
      }
    },
    getAreaTree() {
      areaListLakala().then(response => {
        this.areaList = response.data
      })
    },
    onAreaChange(value, selectedOptions) {
      this.form.merAreaxId = value[2]
      this.form.merRegDistCode = selectedOptions[2].lakalaCode
    },

    getIndustryList() {
      listIndustry({merchantType:this.merchantType}).then(response => {
        this.industryList = response.data
      })
    },
    onIndustryChange(value, selectedOptions) {
      this.form.mccCode = selectedOptions[1].unionPayMcc
    },
    merBlisExpDtLong() {
      this.form.merBlisExpDt= '9999-12-31'
    },

    sameSettleLegal() {
      this.form.acctIdType = this.form.larIdType
      this.form.acctIdcard = this.form.larIdcard
      this.form.acctIdDt = this.form.larIdcardExpDt
      this.form.fileDataResult.settleCardFace = this.form.fileDataResult.legalCardFace
      this.form.fileDataResult.settleCardNational = this.form.fileDataResult.legalCardNational
    },

    getBranchName() {
      if (this.form.openingBankName) {
        return this.form.openingBankName
      } else {
        return this.$t('请选择')+'结算账户开户行名称'
      }
    },
    indexBranchSelect(record) {
      console.log('选中了银行:',record)
      this.form.openingBankName = record.name;
      this.form.openingBankCode = record.code;
      this.form.clearingBankCode = record.clearingCode;
    },

    onClose() {
      this.cancel()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        merchantId: this.merchantId,
        orderNo: null,
        posType: "B2B_CASHIER_DESK",
        orgCode: '986405',
        merRegName: null,
        merBizName: null,
        merAreaxId: null,
        merRegDistCode: null,
        merRegAddr: null,
        mccCode: null,
        merBlisName: null,
        merBlis: null,
        merBlisStDt: null,
        merBlisExpDt: null,
        merBusiContent: undefined,
        larName: null,
        larIdType: "01",
        larIdcard: null,
        larIdcardStDt: null,
        larIdcardExpDt: null,
        merContactMobile: null,
        merContactName: null,
        merContactEmail: null,
        shopName: null,
        shopDistCode: null,
        shopAddr: null,
        shopContactName: null,
        shopContactMobile: null,
        openingBankCode: null,
        openingBankName: null,
        clearingBankCode: null,
        acctNo: null,
        acctName: null,
        acctTypeCode: null,
        settlePeriod: "T+1",
        acctIdType: "01",
        acctIdcard: null,
        acctIdDt: null,
        devSerialNo: null,
        devTypeName: null,
        termVer: null,
        salesStaff: null,
        termNum: null,
        feeDataList: null,
        fileDataList: null,
        contractNo: null,
        feeAssumeType: null,
        amountOfMonth: null,
        serviceFee: null,
        contractId: null,
        contractStatus: '0',
        contractMemo: null,
        merInnerNo: null,
        merCupNo: null,
        limitAmount: null,
        taxPointRange: '0-1',
        fileDataResult : {
          settleCardNational: null,
          settleCardFace: null,
          legalCardNational: null,
          legalCardFace: null,
          businessLicenseImg : null,
          bankCardImg : null,
          doorImg: undefined, //商户门头照
          interiorImg: undefined, //商铺内部照片
          offlinePaperAgreement: undefined, //线下纸质协议
          networkAgreement: undefined,  //电子协议
          cooperation: undefined,  //合作资质证明
          foodBusiness: undefined,  //食品经营相关资质
          unLegalSettleAuthorization : undefined,  //  非法人结算授权书
          cooperationAgreement: undefined, //合作协议
          otherFile: undefined,
        }
      }
      this.areaSelected= []

    },

    openRateType() {
      this.$refs.feeRateForm.show(this.form.feeDataList);
    },
    indexRateType(list) {
      this.form.feeDataList = list
      this.getRateTypeName()
    },
    getRateTypeName() {
      if (this.form.feeDataList && this.form.feeDataList.length>0) {
        let str = ''
        this.form.feeDataList.forEach(e=>{
          str += e.feeRateTypeName  +":"+ e.feeRatePct + '%,   '
        })
        return str.length > 40 ? str.substring(0, 40) + '...' : str
      } else {
        return '配置费率信息'
      }
    },

    /** 新增按钮操作 */
    handleAdd(merchantId, total) {
      this.reset()
      this.formType = 1
        //查询进件记录
      getApplyByMerchantId({"id": merchantId}).then(response => {
        if (total===0) {
          this.form.merRegName = response.data.merchantName;
          this.form.merBizName = response.data.merchantName
          this.form.merRegAddr = response.data.merchantAddress
          this.form.merBlis = response.data.businessLicenceNo
          this.form.fileDataResult.businessLicenseImg = response.data.businessLicenseImg
          this.form.larName = response.data.contactName
          this.form.larIdcard = response.data.contactCardNo
          this.form.fileDataResult.legalCardFace = response.data.contactCardFace
          this.form.fileDataResult.legalCardNational = response.data.contactCardNational
          this.form.merContactName = response.data.contactName
          this.form.merContactEmail = response.data.contactEmail
          if (response.data.branchResult) {
            this.form.openingBankCode = response.data.branchResult.code
            this.form.openingBankName = response.data.branchResult.name
            this.form.clearingBankCode = response.data.branchResult.clearingCode
            this.form.acctNo = response.data.accountNo
            this.form.acctName = response.data.accountName
          }
        }
      })
      this.form.feeDataList=[{"feeRatePct": 0, "feeLowerAmtPcnt": "0", "feeRateTypeCode": "303", "feeRateTypeName": "支付宝", "feeUpperAmtPcnt": "0"}, {"feeRatePct": 0, "feeLowerAmtPcnt": "0", "feeRateTypeCode": "302", "feeRateTypeName": "微信", "feeUpperAmtPcnt": "0"}]
      this.open = true;
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getExtraApplyLakala({"id": id}).then(response => {
        this.form = response.data
        this.open = true
      })
    },
    downLoadTemp() {
      //下载oss 上的excel
      window.open("https://static.byg1688.com/merchant/%E5%8C%85%E5%AE%9C%E8%B4%AD%E5%B9%B3%E5%8F%B0%E5%85%A5%E9%A9%BB%E7%AD%BE%E7%BA%A6%E5%8D%8F%E8%AE%AE.docx","_blank")
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateExtraApplyLakala(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message, 3);
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addExtraApplyLakala(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="less">
.goods-collapse > .ant-collapse-header {
  color: #0e75d3 !important;
  background: #e8eef9;
}
</style>
